import PropTypes from 'prop-types'
import { useMandateWizardContext } from '../MandateWizardContext'
import Step from './Step'

const InitialStep = ({ title }) => {
  const {
    initialStepQuestions,
    initialStepAnswers,
    setInitialStepAnswers,
    handleNextInitialStep,
  } = useMandateWizardContext()

  return (
    <Step
      title={title}
      questions={initialStepQuestions}
      answers={initialStepAnswers}
      onSetAnswers={setInitialStepAnswers}
      onNextStep={handleNextInitialStep}
      isFirst={true}
    />
  )
}

InitialStep.propTypes = {
  title: PropTypes.string,
}

export default InitialStep
